import { useState } from 'react';
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import ApiService from '../../../../../ApiService';
import Block from '../../../../../components/Block';

import { CampaignChangeRequest } from '../../../../../types/Campaign';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import CampaignChangeRequestDataGrid from '../DataGrid/CampaignChangeRequestDataGrid';
import CampaignChangeRequestDrawer from '../Drawer/CampaignChangeRequestDrawer';
import Utils from '../../../../../components/Utils';

const CampaignPageChangeHistoryPageTab = () => {
    const { campaign, setCampaign } = useCampaignPageContext();
    const [activeCampaignChangeRequest, setCampaignChangeRequest] = useState<CampaignChangeRequest | undefined>(
        undefined
    );

    const { data, isLoading, refetch } = useQuery<CampaignChangeRequest[]>({
        enabled: !!campaign.id,
        refetchOnWindowFocus: false,
        queryKey: ['campaign/adGroup/dspAdCreatives', campaign.id],
        queryFn: async () => {
            const { data } = await ApiService.getCampaignChangeRequests(campaign.id as number);

            return data;
        },
    });

    const handleOnApprove = (): void => {
        setCampaignChangeRequest(undefined);
        refetch();
        if (campaign.id) {
            ApiService.getCampaign(campaign.id).then((response) => {
                response.data.startDate = response.data.startDate ? Utils.toLocalTime(response.data.startDate) : null;
                response.data.endDate = response.data.endDate ? Utils.toLocalTime(response.data.endDate) : null;
                setCampaign(response.data);
            });
        }
    };

    const handleOnDecline = (): void => {
        setCampaignChangeRequest(undefined);
        refetch();
        if (campaign.id) {
            ApiService.getCampaign(campaign.id).then((response) => {
                response.data.startDate = response.data.startDate ? Utils.toLocalTime(response.data.startDate) : null;
                response.data.endDate = response.data.endDate ? Utils.toLocalTime(response.data.endDate) : null;
                setCampaign(response.data);
            });
        }
    };

    const handleOnCancel = (): void => {
        setCampaignChangeRequest(undefined);
    };

    return (
        <Box>
            <Block>
                <CampaignChangeRequestDataGrid
                    rows={data || []}
                    loading={isLoading}
                    action={{
                        name: 'Review',
                        callback: (campaignChangeRequest: CampaignChangeRequest): void => {
                            setCampaignChangeRequest(campaignChangeRequest);
                        },
                    }}
                />
            </Block>

            {activeCampaignChangeRequest && (
                <CampaignChangeRequestDrawer
                    open={!!activeCampaignChangeRequest}
                    campaignChangeRequest={activeCampaignChangeRequest}
                    onCancel={handleOnCancel}
                    onApprove={handleOnApprove}
                    onDecline={handleOnDecline}
                />
            )}
        </Box>
    );
};

export default CampaignPageChangeHistoryPageTab;
